import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowLeft, Bookmark } from "lucide-react";
import FootnoteManager from "./FootnoteManager";

const Footnotes = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <header className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Link to="/dashboard">
                <Button variant="ghost" size="sm">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Dashboard
                </Button>
              </Link>
              <div>
                <h1 className="text-xl font-bold text-slate-800 flex items-center">
                  <Bookmark className="w-5 h-5 mr-2 text-blue-500" />
                  Footnotes
                </h1>
                <p className="text-sm text-slate-500">Manage your reusable text snippets</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-8">
        <FootnoteManager />
      </main>
    </div>
  );
};

export default Footnotes;